export function isWebpackDefinePluginAvailable(): boolean {
  return true;
}
